import { render, staticRenderFns } from "./AddContractorToManagerNew.vue?vue&type=template&id=4c6718f3&scoped=true"
import script from "./AddContractorToManagerNew.vue?vue&type=script&lang=ts"
export * from "./AddContractorToManagerNew.vue?vue&type=script&lang=ts"
import style0 from "./AddContractorToManagerNew.vue?vue&type=style&index=0&id=4c6718f3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6718f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6718f3')) {
      api.createRecord('4c6718f3', component.options)
    } else {
      api.reload('4c6718f3', component.options)
    }
    module.hot.accept("./AddContractorToManagerNew.vue?vue&type=template&id=4c6718f3&scoped=true", function () {
      api.rerender('4c6718f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/AddContractorToManagerNew.vue"
export default component.exports